const USER_ROLE = {
  DISABLED: 0,
  ADMIN: 1,
  CORRESPONDENT: 2,
  USER: 3,
  CLERKSHIP: 4,
  AUDITOR: 5,
  REGISTRANT: 6,
}

const ENTITY_TYPE = {
  TASK: 1,
  DOCUMENT_AGREEMENT: 2,
  ORDER: 3,
  CORRESPONDENCE: 4,
  CONTRACTOR: 5,
  USER: 6,
  DEPARTMENT: 7,
  DOCUMENT_SIGNATURE: 8,
  AUDIT_RECOMMENDATION: 9,
  PROTOCOL: 10,
  INCIDENT_ISSUE: 12,
  INCIDENT: 13,
}

export { USER_ROLE, ENTITY_TYPE }
